import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { useGetExperimentValue } from '@trello/feature-gate-client';

import {
  PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE,
  PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED,
} from 'app/src/components/InboxNotifications/InboxNotifications.constants';

export const usePlannerDiscoveryCardEligibility: ({
  cardId,
}: {
  cardId: string;
}) =>
  | {
      isEligible: false;
      variation: null;
    }
  | {
      isEligible: true;
      variation: 'with-cta' | 'without-cta';
    } = ({ cardId }) => {
  const { isOneTimeMessageDismissed } = useOneTimeMessagesDismissed();

  const { cohort: addToInboxCohort, loading: addToInboxCohortLoading } =
    useGetExperimentValue({
      experimentName: 'ghost_add_to_inbox',
      parameter: 'cohort',
      fireExposureEvent: false,
    });

  const isIncludedCohort = ['treatment-a', 'treatment-b'].includes(
    addToInboxCohort,
  );

  if (
    addToInboxCohortLoading ||
    !isIncludedCohort ||
    !(
      isOneTimeMessageDismissed(
        `${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE}:${cardId}`,
      ) ||
      isOneTimeMessageDismissed(
        `${PLANNER_DISCOVERY_CARD_ONE_TIME_MESSAGE_DISMISSED}:${cardId}`,
      )
    )
  ) {
    return {
      isEligible: false,
      variation: null,
    };
  } else {
    const variation =
      addToInboxCohort === 'treatment-a' ? 'with-cta' : 'without-cta';
    return {
      isEligible: true,
      variation,
    };
  }
};
